import Axios from "axios";

export const GlobalController = {
  GetAddress: function (cep, res) {
      Axios.get(`https://viacep.com.br/ws/${cep}/json`, {})
        .then(function (response) {
          
          res({ ...response.data });
        })
        .catch(function (error) {
          if (error) {
          }
        });
    },

  GetPostalCodeInternacional: function (cep, result) {
    Axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${cep}&country:PH&key=AIzaSyAjHY1raiZKuwktiRYHUyqj7RVFeNrl6FQ`,
      {}
    )
      .then(function (response) {
        if (response.data !== null && response.data.results !== undefined) {
          let res = response.data.results[0];
          let infos = { address: res.formatted_address, ...response };
          result(infos);
        }
      })
      .catch(function (error) {
        if (error) {
          console.log("Não foi possível encontrar o endereço", error);
        }
    });
  }
}